module.exports = __webpack_public_path__ + "static/img/20002 (3).611ef06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (3).jpg
// module id = 8zAA
// module chunks = 14